import { callApi } from "@src/utils/api-client";
import ClientLogsService from "./client-logs.service";
import { buildUserDigitalInfoConfig } from "./configs";

export interface DigitalFingerprint {
  browser_name: string | null;
  browser_version: string | null;
  os_name: string | null;
  os_version?: string | null;
  device_type: string | null;
  language: string | null;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_theme?: string;
}
export interface UserDigitalInfoResponse {
  success?: boolean;
  message?: string;
  transactionID?: string;
  error?: string;
}

export async function postUserDigitalInfo(
  userId: string,
  payload: DigitalFingerprint,
): Promise<UserDigitalInfoResponse> {
  try {
    const { data, response } = await callApi(buildUserDigitalInfoConfig(userId, payload));

    if (!response.ok) {
      return {
        error:
          (typeof data === "object" && data !== null && "message" in data
            ? (data as { message?: string }).message
            : undefined) ?? "Failed to post user digital info",
      };
    }

    return (data as UserDigitalInfoResponse) ?? {};
  } catch (error) {
    ClientLogsService.logError(
      userId || "unknown",
      "user-digital-info.service.postUserDigitalInfo",
      "Error posting user digital info",
      error instanceof Error ? error : new Error("Unknown error"),
      {
        errorType: "DependencyFailure",
        dependencyName: "UserDigitalInfoAPI",
        functionName: "postUserDigitalInfo",
      },
    );
    return {
      error: error instanceof Error ? error.message : "Unexpected error",
    };
  }
}
